import { XAxis, YAxis } from 'react-stockcharts/lib/axes';
import styled from 'styled-components';

export const AreaChartWrapper = styled.div`
  max-width: 750px;
  height: 450px;
  padding: 0 51px;
  position: relative;
  background: #fff;
  width: 50%;
  box-shadow: 0px 20px 40px 0px #19192e0d;
  * {
    cursor: unset !important;
  }

  @media (max-width: 1100px) {
    width: 100%;
    height: auto;
  }

  @media (max-width: 600px) {
    background: transparent;
    box-shadow: none;
    padding: 0 20px;
  }
`;

export const ChartStyled = styled.div`
  height: 316px;
  max-width: 596px;
  width: 100%;
  margin-top: 39px;
`;

export const XAxsisStyled = styled(XAxis)`
  text {
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 16px;
    fill: #aeb6ce;
  }

  line {
    opacity: 0;
  }

  path {
    stroke: #bcbcfe;
    stroke-width: 2px;
    stroke-dasharray: 2px;
  }
`;

export const YAxsisStyled = styled(YAxis)`
  line {
    stroke-dasharray: 0;
    opacity: 0;
  }

  path {
    opacity: 0;
  }
`;

export const LeftSideLine = styled.line`
  stroke: #bcbcfe;
  stroke-width: 2px;
  stroke-dasharray: 2px;
`;
